module.exports = __webpack_public_path__ + "img/mu.896330b7.svg";